

import { Incarico } from './incarico';
import { Model } from './model';
import { Polizza } from './polizza';

export class WorkflowStep extends Model {
  static apiUrl: string = "workflows";

  nome: string;
  descrizione: string;
  incarichi: Incarico[];

  deserialize(input: any): WorkflowStep {
    let retV: WorkflowStep = new WorkflowStep();

    retV = super.deserialize(input) as WorkflowStep;

    if (input?.descrizione !== undefined) {
      retV.descrizione = input.descrizione;
    }

    if (input?.incarichi) {
      retV.incarichi = input.incarichi.map(m => new Incarico().deserialize(m));
    } 
    return retV;
  }

}
